import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen p-6 text-center bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-100"
          style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}
        >
          <h1 className="text-2xl font-semibold mb-3">Something went wrong</h1>
          <p className="text-base text-gray-500 dark:text-gray-400 mb-6 max-w-[400px]">
            The app ran into an unexpected error. Reloading usually fixes it.
          </p>
          <button
            onClick={this.handleReload}
            className="px-8 py-3 text-base font-semibold text-white bg-blue-600 dark:bg-blue-500 rounded-lg cursor-pointer border-none hover:bg-blue-700 dark:hover:bg-blue-600 transition-colors"
          >
            Reload App
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
